"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnEvent = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = require("react");

var _useContextProvider2 = require("./useContextProvider");

var _types = require("../types");

var _api = require("../api");

var _errorWhitelist = require("../constants/errorWhitelist");

var _browserRum = require("@datadog/browser-rum");

var useOnEvent = function useOnEvent(adapter) {
  var _useContextProvider = (0, _useContextProvider2.useContextProvider)(),
      state = _useContextProvider.state,
      config = _useContextProvider.config;

  var onEvent = config.onEvent;
  var userToken = (config === null || config === void 0 ? void 0 : config.userToken) || state.userToken;
  var api = (0, _api.getBankConnectApi)(userToken, adapter);
  var dispatchEvent = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
      var error;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(e.type === _types.FiConnectEventTypes.ERROR)) {
                _context.next = 7;
                break;
              }

              if (!(0, _errorWhitelist.isWhitelistedError)(e.errorCode)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              error = e;

              _browserRum.datadogRum.addError(error, undefined);

              _context.next = 7;
              return (0, _api.submitError)(api)({
                error: error.error,
                errorCode: error.errorCode || 500,
                userToken: userToken
              }).catch(function (e) {
                return console.error(e, 'Error submitting error');
              });

            case 7:
              onEvent(e); // eslint-disable-next-line react-hooks/exhaustive-deps

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  return dispatchEvent;
};

exports.useOnEvent = useOnEvent;